import { Select } from '@dreryk/react-components';

import { medicineTranslationKeys } from '~libs.desktop.shared.medicine';

import { ExtendedDosageFormController } from '../ExtendedDosageForm.types';
import { ADMINISTRATION_INTERVAL_DAYS, AdministrationIntervalDays } from '../../extendedDosage.utils';

import { useAdministrationIntervalLabelExtractor } from './AdministrationIntervalSelect.hooks';
import { StyledAdministrationIntervalSelect } from './AdministrationIntervalSelect.styled';
import { useStageFieldValidationRules } from './DosagePeriodField.hooks';
import { registerStageField, StageFieldName } from './StageFieldList.utils';

type AdministrationIntervalSelectProps = Pick<ExtendedDosageFormController, 'register' | 'trigger'> & {
   readonly name: StageFieldName;
   readonly defaultValue: AdministrationIntervalDays;
   readonly invalid: boolean;
   readonly testId: string;
};

export const AdministrationIntervalSelect = (props: AdministrationIntervalSelectProps): JSX.Element => {
   const intervalLabelExtractor = useAdministrationIntervalLabelExtractor();
   const validationRules = useStageFieldValidationRules({
      trigger: props.trigger,
      name: props.name,
      invalid: props.invalid,
   });

   return (
      <StyledAdministrationIntervalSelect<AdministrationIntervalDays>
         testId={props.testId}
         triggerLabelExtractor={intervalLabelExtractor}
         controller={registerStageField<AdministrationIntervalDays>(props.register, props.name, validationRules)}
         defaultValue={props.defaultValue}
         compact
      >
         <Select.List<AdministrationIntervalDays> items={[...ADMINISTRATION_INTERVAL_DAYS]}>
            {(days: AdministrationIntervalDays) => (
               <Select.Item
                  item={days}
                  testId={String(days)}
                  key={days}
                  label={medicineTranslationKeys.extendedDosage.administrationIntervalMap[days]}
               />
            )}
         </Select.List>
      </StyledAdministrationIntervalSelect>
   );
};
